import { Injectable } from '@angular/core';
import Swal, { SweetAlertIcon, SweetAlertPosition } from 'sweetalert2';

@Injectable({
  providedIn: 'root'
})
export class AlertService {

  constructor() { }

  // Temel uyarı kutusu
  showAlert(
    title: string, 
    text: string, 
    icon: SweetAlertIcon = 'info',
    confirmButtonText: string = 'Tamam',
    position: SweetAlertPosition = 'center' // All positions available
  ) {
    return Swal.fire({
      title,
      text,
      icon,
      confirmButtonText,
      heightAuto: false,
      position
    });
  }

  // Toast bildirimi
  showToast(
    title: string, 
    icon: SweetAlertIcon = 'success', 
    position: SweetAlertPosition = 'center', // All positions available
    timer: number = 3000,
    showCloseButton: boolean = false
  ) {
    const toast = Swal.mixin({
      toast: true,
      position,
      showConfirmButton: false,
      showCloseButton,
      timer,
      timerProgressBar: true,
      didOpen: (toast) => {
        toast.addEventListener('mouseenter', Swal.stopTimer);
        toast.addEventListener('mouseleave', Swal.resumeTimer);
      }
    });

    return toast.fire({
      icon,
      title
    });
  }

  // Onay iletişim kutusu
  showConfirm(
    title: string,
    text: string,
    confirmButtonText: string = 'Evet',
    cancelButtonText: string = 'İptal',
    icon: SweetAlertIcon = 'question',
    position: SweetAlertPosition = 'center' // All positions available
  ) {
    return Swal.fire({
      title,
      text,
      icon,
      position,
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText,
      cancelButtonText,
      heightAuto: false
    });
  }

  // Hata mesajı kısayolu
  showError(
    text: string, 
    title: string = 'Hata!',
    position: SweetAlertPosition = 'center' // All positions available
  ) {
    return this.showAlert(title, text, 'error', 'Tamam', position);
  }

  // Başarı mesajı kısayolu
  showSuccess(
    text: string, 
    title: string = 'Başarılı!',
    position: SweetAlertPosition = 'center' // All positions available
  ) {
    return this.showAlert(title, text, 'success', 'Tamam', position);
  }

  // Uyarı mesajı kısayolu
  showWarning(
    text: string, 
    title: string = 'Uyarı!',
    position: SweetAlertPosition = 'center' // All positions available
  ) {
    return this.showAlert(title, text, 'warning', 'Tamam', position);
  }

  // Uyarı toast kısayolu
  showWarningToast(
    title: string, 
    position: SweetAlertPosition = 'center', // All positions available
    timer: number = 4000
  ) {
    return this.showToast(title, 'warning', position, timer);
  }

  // Özelleştirilmiş uyarı kutusu
  showAdvancedWarning(
    title: string,
    text: string,
    confirmButtonText: string = 'Anladım',
    showCancelButton: boolean = false,
    cancelButtonText: string = 'İptal',
    position: SweetAlertPosition = 'center' // All positions available
  ) {
    return Swal.fire({
      title,
      text,
      icon: 'warning',
      position,
      showCancelButton,
      confirmButtonColor: '#ff9800',
      cancelButtonColor: '#d33',
      confirmButtonText,
      cancelButtonText: showCancelButton ? cancelButtonText : undefined,
      heightAuto: false
    });
  }
}